export const invokeMobileShareDialog = ({
  title,
  text,
  url,
}: {
  title: string;
  text: string;
  url: string;
}) => {
  navigator?.share &&
    navigator
      .share({
        title: title,
        text: text,
        url: url,
      })
      .then(() => true)
      .catch((error: Error) => {
        console.error(error);
      });
};
